import React, { useState, useEffect, useRef, useMemo, useCallback, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import CountrySelectInput from "../shared/countrySelectInput";
import { FaArrowLeft, FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import { api, API_BASE_URL, API_DEPLOYED_URL } from "../../config/api";
import { useMyContext } from "../../context/MyContext";
import { CurrencyContext } from "../../context/CurrencyContext";
import CreatableSelect from "react-select/creatable";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import { getAllAdminUsers, getAllSuperAdminUsers } from "../../lib/user";
import Modal from "react-modal";
import { generateIOR } from "../shared/pdf/generateIOR";
import { FaRegEye, FaDownload } from "react-icons/fa6";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import { Select } from "antd";
import { countries } from "../shared/countrySelectInput/countries";
import { responsiveArray } from "antd/es/_util/responsiveObserver";
import { FaSpinner, FaEnvelope, FaBell } from "react-icons/fa";
import WarningPopup from './WarningPopup';
import EstimateSummaryWithDHL from './EstimateSummaryWithDHL';
import { evaluateComplexFormula, calculateServiceValue } from '../../utils/estimateUtils';
import { CANADIAN_PROVINCES, BRAZILIAN_STATES } from '../../utils/states';
import AsyncSelect from 'react-select/async';

Modal.setAppElement("#root");

const EstimateForm = ({ onBack, estimate, fetchEstimates, isNewEstimate }) => {
  const { estimateId } = useParams();
  const { user } = useMyContext();
  const { currencies } = useContext(CurrencyContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [warningPopup, setWarningPopup] = useState({ isOpen: false, message: "" });

  // Unit conversion functions
  const convertLbsToKg = (lbs) => {
    return lbs * 0.453592;
  };

  const convertInchesToCm = (inches) => {
    return inches * 2.54;
  };

  const convertKgToLbs = (kg) => {
    return kg / 0.453592;
  };

  const convertCmToInches = (cm) => {
    return cm / 2.54;
  };

  // Helper function to get converted weight in kg
  const getWeightInKg = (weight) => {
    if (!weight || !weight.value) return 0;
    const value = parseFloat(weight.value);
    return weight.unit === 'lbs' ? convertLbsToKg(value) : value;
  };

  // Helper function to get converted dimension in cm
  const getDimensionInCm = (dimension) => {
    if (!dimension || !dimension.value) return 0;
    const value = parseFloat(dimension.value);
    return dimension.unit === 'in' ? convertInchesToCm(value) : value;
  };

  const [formData, setFormData] = useState({
    userId: user.uid,
    userName: user.name,
    userCity: user.city,
    userCountry: user.country,
    postalCode: user.postalCode,
    insuranceSelected: "NO",
    email: user.email,
    currency: "USD",
    itemsCurrency: "USD",
    selectedService: "IOR",
    hsCode: "",
    dimensions: [
      {
        weight: { value: "", unit: "kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
        quantity: { value: '' }
      }
    ],
    originCountry: "",
    originState: "",
    destinationCountry: "",
    destinationState: "",
    destinationCity: "",
    originCity: "",
    status: false,
    pending: "",
    requiredDoc: "not_Required",
    items: [
      {
        itemName: "",
        itemHSCode: "",
        itemValue: "",
        countryOrigin: "",
        quantity: "",
        hasHSCode: null,
        itemNew: true,
        hsCodeSource: "database", // Add this new field
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [calculatedValues, setCalculatedValues] = useState({});
  const [adminEstimate, setAdminEstimate] = useState(null);
  const [showEstimateResults, setShowEstimateResults] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [buttonText, setButtonText] = useState(
    isNewEstimate ? "Get Estimate" : "Update Estimate"
  );
  const [estimateSummary, setEstimateSummary] = useState(null);
  const [isHSCodeRelated, setIsHSCodeRelated] = useState(false);
  const [clientEstimateSummary, setClientEstimateSummary] = useState(null);
  const [itemsTotalQty, setItemsTotalQty] = useState(0); // Item Quantity
  const [totalItemsValue, setTotalItemsValue] = useState(0);
  const [totalItemsQuantity, setTotalItemsQuantity] = useState(0); // Pallet/Box Quantity
  const [totalDimensionsWeight, setTotalDimensionsWeight] = useState(0);
  const [totalDimensionsLength, setTotalDimensionsLength] = useState(0);
  const [totalDimensionsWidth, setTotalDimensionsWidth] = useState(0);
  const [totalDimensionsHeight, setTotalDimensionsHeight] = useState(0);
  const location = useLocation();
  const isIorCalculatorRoute = location.pathname.includes('ior-calculator');
  const [showButton, setShowButton] = useState(true);
  const [insurance, setInsurance] = useState(0);
  const [airfreight, setAirfreight] = useState(0);
  const [cif, setCif] = useState(0);
  const [dhlEstimation, setDhlEstimation] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [tokenExpiry, setTokenExpiry] = useState(null);
  const [freightCharge, setFreightCharge] = useState(0);
  const [insuranceCharge, setInsuranceCharge] = useState(0);
  const [transportMode, setTransportMode] = useState('AIR');
  const [pricingStrategy, setPricingStrategy] = useState('EXACT');
  const [senderState, setSenderState] = useState('');
  const [receiverState, setReceiverState] = useState('');
  const [eccnCodes, setEccnCodes] = useState([]);
  console.log('~~~~~~~~~~~~~~~~~~~~eccnCodes', eccnCodes)
  const [selectedEccn, setSelectedEccn] = useState(null);

  const [duty, setDuty] = useState(0);
  const [collectionValue, setCollectionValue] = useState(0);
  const [disabledCountries, setDisabledCountries] = useState([]);
  const [disabledDutyVatCountries, setDisabledDutyVatCountries] = useState([]);

  const closeModal = () => {
    setIsModalOpen(false);
    // onBack();
  };

  const shouldShowBackButton = () => {
    return location.state?.fromNewRequest === true;
  };

  /**
 * Handles changes to dimension fields (weight, length, width, height, quantity) and their units.
 * Updates only the specific dimension entry being edited, allowing each entry to have independent units.
 * Relies on a useEffect hook listening to `formData.dimensions` to recalculate totals.
 */
  const handleDimensionChange = (index, field, e) => {
    const { value, name } = e.target;
    const isUnitChange = name && name.includes('unit');

    setFormData(prevData => {
      // Create a new array to avoid direct state mutation
      const newDimensions = prevData.dimensions.map((dim, i) => {
        if (i === index) {
          // This is the dimension entry we want to change
          const updatedDim = { ...dim };

          if (isUnitChange) {
            if (field === 'height') {
              // If height's unit changes, apply it to length and width of the same entry
              updatedDim.length = { ...updatedDim.length, unit: value };
              updatedDim.width = { ...updatedDim.width, unit: value };
              updatedDim.height = { ...updatedDim.height, unit: value };
            } else {
              // For other fields (e.g., weight), just update its own unit
              updatedDim[field] = { ...updatedDim[field], unit: value };
            }
          } else {
            // This is a value change for any field (weight, length, width, height, quantity)
            updatedDim[field] = { ...updatedDim[field], value: value };
          }
          return updatedDim;
        }
        return dim; // Return other dimensions unchanged
      });

      return {
        ...prevData,
        dimensions: newDimensions
      };
    });
  };


  /**
   * Adds a new dimension entry to the form.
   * The new entry inherits its units from the last existing dimension entry for better user experience.
   */
  const handleAddDimension = () => {
    setFormData(prevData => {
      const lastDimension = prevData.dimensions[prevData.dimensions.length - 1];
      const currentWeightUnit = lastDimension.weight.unit;
      const currentDimensionUnit = lastDimension.height.unit;

      return {
        ...prevData,
        dimensions: [
          ...prevData.dimensions,
          {
            weight: { value: "", unit: currentWeightUnit },
            length: { value: "", unit: currentDimensionUnit },
            width: { value: "", unit: currentDimensionUnit },
            height: { value: "", unit: currentDimensionUnit },
            quantity: { value: "" }
          }
        ]
      };
    });
  };


  const handleRemoveDimension = (index) => {
    if (formData.dimensions.length > 1) {
      setFormData(prevData => ({
        ...prevData,
        dimensions: prevData.dimensions.filter((_, i) => i !== index)
      }));
    }
  };

  useEffect(() => {
    const fetchDisabledCountries = async () => {
      try {
        const response = await api.get(`${API_BASE_URL}/countries/disabled`);
        setDisabledCountries(response.data);
      } catch (error) {
        console.error('Error fetching disabled countries:', error);
      }
    };
    const fetchDisabledDutyVatCountries = async () => {
      try {
        const response = await api.get(`${API_BASE_URL}/duty-vat/disabled`);
        setDisabledDutyVatCountries(response.data);
      } catch (error) {
        console.error('Error fetching disabled duty & VAT countries:', error);
      }
    };
    fetchDisabledCountries();
    fetchDisabledDutyVatCountries();
  }, []);

  useEffect(() => {
    const fetchEccnCodes = async () => {
      try {
        const response = await api.get(`${API_BASE_URL}/eccn`);
        setEccnCodes(response.data);
      } catch (error) {
        console.error("Error fetching ECCN codes:", error);
        toast.error("Failed to load ECCN codes");
      }
    };
    fetchEccnCodes();
  }, []);

  useEffect(() => {
    if (selectedEccn) {
      setFormData(prev => ({
        ...prev,
        eccnCode: selectedEccn
      }));
    }
  }, [selectedEccn]);

  const renderEccnOption = (eccn) => (
    <div className="flex flex-col py-2 px-3 hover:bg-blue-50 transition-colors">
      <div className="flex justify-between items-center">
        <span className="font-semibold text-blue-600">{eccn.eccn_code}</span>
        <span className={`text-xs px-2 py-1 rounded-full ${eccn.restrictions ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
          {eccn.restrictions ? 'Restricted' : 'Unrestricted'}
        </span>
      </div>
      <span className="text-sm text-gray-600 mt-1">{eccn.description}</span>
    </div>
  );

  const fetchClientEstimateSummary = async (id) => {
    try {
      const response = await api.get(`${API_BASE_URL}/clientestimates/summary/${id}`);
      const newSummary = response.data.estimateSummary;

      if (JSON.stringify(clientEstimateSummary) !== JSON.stringify(newSummary)) {
        setClientEstimateSummary(newSummary);
      }
      return newSummary;
    } catch (error) {
      console.error("Error fetching client estimate summary:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (estimateId) {
        await fetchEstimateData(estimateId);
        await fetchClientEstimateSummary(estimateId);
      } else if (estimate && estimate.estimateId) {
        await fetchClientEstimateSummary(estimate.estimateId);
      }
      if (adminEstimate &&
        (!formData.estimateSummary ||
          formData.estimateSummary.total === 0 ||
          formData.estimateSummary.services.length === 0)) {
        await updateClientEstimateWithAdminServices(adminEstimate);
      }
    };
    fetchData();
  }, [estimateId, estimate, adminEstimate]);

  useEffect(() => {
    let intervalId;
    const idToUse = estimateId || (estimate && estimate.estimateId);

    if (idToUse && !loading && !showEstimateResults) {
      fetchClientEstimateSummary(idToUse);
      intervalId = setInterval(() => {
        if (!loading) {
          fetchClientEstimateSummary(idToUse);
        }
      }, 10000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [estimateId, estimate, loading]);

  useEffect(() => {
    if (estimate) {
      setFormData((prevData) => ({
        ...prevData,
        items: prevData.items.map((item) => ({
          ...item,
          hasHSCode: Boolean(item.hasHSCode),
        })),
      }));
    }
  }, [estimate]);

  useEffect(() => {
    const fetchData = async () => {
      if (estimateId) {
        await fetchEstimateData(estimateId);
      } else if (estimate) {
        setFormData((prevData) => ({
          ...prevData,
          ...estimate,
          dimensions: estimate.dimensions ? estimate.dimensions : [
            {
              weight: { value: estimate.weight.value, unit: estimate.weight.unit },
              length: { value: estimate.length.value, unit: estimate.length.unit },
              width: { value: estimate.width.value, unit: estimate.width.unit },
              height: { value: estimate.height.value, unit: estimate.height.unit },
            },
          ],
          originCountry: estimate.loadCountry,
          destinationCountry: estimate.unloadCountry,
          originState: estimate.originState || "",
          destinationState: estimate.destinationState || "",
          items: estimate.items || [],
          items: estimate.items.map((item) => ({
            ...item,
            hasHSCode: !!item.itemHSCode,
            hsCodeSource: item.hsCodeSource || "database", // Add default if not present
          })),
        }));
      }
    };
    fetchData();
  }, [estimateId, estimate]);

  const fetchEstimateData = async (id) => {
    if (loading) return;

    setLoading(true);
    try {
      const response = await api.get(
        `${API_BASE_URL}/clientestimates/id/${id}`
      );
      const estimateData = response.data;

      setFormData((prevData) => ({
        ...prevData,
        ...estimateData,
        dimensions: estimateData.dimensions || [
          {
            weight: { value: "", unit: "kg" },
            length: { value: "", unit: "cm" },
            width: { value: "", unit: "cm" },
            height: { value: "", unit: "cm" },
            quantity: { value: "" }
          }
        ],
        originState: estimateData.originState || "",
        destinationState: estimateData.destinationState || "",
        items: estimateData.items ? estimateData.items.map((item) => ({
          ...item,
          hasHSCode: !!item.itemHSCode,
          hsCodeSource: item.hsCodeSource || "database", // Add default if not present
        })) : []
      }));

      if (estimateData.originCountry &&
        estimateData.destinationCountry &&
        !adminEstimate) {
        await fetchAdminEstimate(
          estimateData.originCountry,
          estimateData.destinationCountry,
          formData.selectedService,
          formData.itemsCurrency,
          "kg"  // Always pass "kg" to fetchAdminEstimate
        );
      }

      await fetchClientEstimateSummary(id);

    } catch (error) {
      console.error("Error fetching estimate data:", error);
      toast.error("Failed to load estimate data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formData.status) {
    }
  }, [
    formData.status,
    formData.originCountry,
    formData.destinationCountry,
    formData.itemValue,
    formData.dimensions.map(dimension => ({
      length: dimension.length,
      width: dimension.width,
      height: dimension.height,
      quantity: dimension.quantity
    })),
  ]);

  const fetchAdminEstimate = async (
    loadCountry,
    unloadCountry,
    selectedTemplate,
    airfreightCurrency,
    afcWeightUnit = "kg"  // Default to "kg" and always use "kg"
  ) => {
    if (!loadCountry || !unloadCountry || !selectedTemplate || !airfreightCurrency || !afcWeightUnit) {
      // Don't make an API call if essential parameters are missing.
      return;
    }

    // console.log("Fetching admin estimate with params:", {
    //   loadCountry,
    //   unloadCountry,
    //   selectedTemplate,
    //   airfreightCurrency,
    //   afcWeightUnit,
    // });

    // Always use "kg" for the API call regardless of the passed parameter
    const standardizedWeightUnit = "kg";

    try {
      // MODIFICATION: Call the new, optimized endpoint instead of fetching all estimates.
      // Pass the form data as query parameters for the backend to handle filtering.
      const response = await api.get(`${API_BASE_URL}/estimates/estimate-lookup`, {
        params: {
          loadCountry,
          unloadCountry,
          selectedTemplate,
          airfreightCurrency,
          afcWeightUnit: standardizedWeightUnit, // Always use "kg"
        },
        timeout: 15000, // 15-second timeout as a safeguard
      });

      const potentialMatches = response.data; // This will be a small array or empty

      // console.log("Received potential matches from /estimate-lookup:", potentialMatches);

      if (potentialMatches && potentialMatches.length > 0) {
        // The client-side find is now extremely fast as it runs on a tiny array (usually 1 item).
        // This logic remains to ensure we pick the exact match if the DB query returns multiple.
        const exactMatch = potentialMatches.find((estimate) => {
          const loadCountryMatch = Array.isArray(estimate.loadCountry)
            ? estimate.loadCountry.includes(loadCountry)
            : estimate.loadCountry === loadCountry;

          return (
            loadCountryMatch &&
            estimate.unloadCountry === unloadCountry &&
            estimate.selectedTemplate?.name === selectedTemplate &&
            estimate.afcWeightUnit === standardizedWeightUnit &&  // Use standardized unit
            estimate.airfreightCurrency === airfreightCurrency
          );
        });

        if (exactMatch) {
          // console.log("Found exact match:", exactMatch.estimateId);
          setAdminEstimate(exactMatch);
          const pendingServices =
            exactMatch.selectedTemplate?.services
              ?.filter((service) => service.values?.includes("Pending"))
              ?.map((service) => service.description) || [];

          setFormData((prevData) => ({
            ...prevData,
            airfreightCurrency: exactMatch.airfreightCurrency,
            afcWeightUnit: exactMatch.afcWeightUnit,
            selectedTemplate: exactMatch.selectedTemplate,
            pending: pendingServices.join(", "),
          }));
        } else {
          console.warn("No exact match found in the potential matches.");
          setAdminEstimate(null); // Clear previous admin estimate if no match is found
        }
      } else {
        console.warn("No estimates returned from the lookup API.");
        setAdminEstimate(null); // Clear if no results
      }
    } catch (error) {
      console.error("Error fetching admin estimate configuration:", error);
      // Avoid showing an error toast for a 404-like scenario (no estimate found)
      // Only show toast for actual server/network errors.
      if (error.response?.status !== 404) {
        toast.error("Could not load estimation rules. Please try again.");
      }
      setAdminEstimate(null);
    }
  };

  const updateClientEstimateWithAdminServices = async (adminEstimate) => {
    try {
      const calculatedServices = adminEstimate.selectedTemplate.services.map(service => ({
        description: service.description,
        value: calculateServiceValue(
          service,
          formData,
          calculatedValues,
          totalItemsValue,
          totalDimensionsWeight,
          totalDimensionsLength,
          totalDimensionsWidth,
          totalDimensionsHeight,
          cif,
          insurance,
          totalItemsQuantity,
          itemsTotalQty
        )
      }));

      const total = calculatedServices.reduce((sum, service) => sum + service.value, 0);

      const updatedEstimateData = {
        ...formData,
        selectedTemplate: adminEstimate.selectedTemplate,
        estimateSummary: {
          total: total,
          currency: adminEstimate.airfreightCurrency || "USD",
          services: calculatedServices,
        },
      };

      const response = await api.put(
        `${API_BASE_URL}/clientestimates/id/${estimate.estimateId}`,
        updatedEstimateData
      );

      setFormData(updatedEstimateData);
      setEstimateSummary(updatedEstimateData.estimateSummary);
    } catch (error) {
      console.error(
        "Error updating client estimate with admin services:",
        error
      );
    }
  };

  const handleInsuranceChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      insuranceSelected: value,
    }));
    const calculatedInsurance = value === 'YES' ? totalItemsValue * 0.0075 : 0;
    setInsurance(calculatedInsurance);

    const updatedCIF = totalItemsValue + airfreight + calculatedInsurance + duty + collectionValue;
    setCif(updatedCIF);
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (
        formData.originCountry &&
        formData.destinationCountry &&
        formData.selectedService &&
        formData.itemsCurrency &&
        formData.dimensions[0]?.weight?.unit &&
        !loading
      ) {
        fetchAdminEstimate(
          formData.originCountry,
          formData.destinationCountry,
          formData.selectedService,
          formData.itemsCurrency,
          "kg"  // Always pass "kg" regardless of form weight unit
        );
      }
    }, 500);

    return () => clearTimeout(debounceTimeout);
  }, [
    formData.originCountry,
    formData.destinationCountry,
    formData.selectedService,
    formData.itemsCurrency,
    formData.dimensions[0]?.weight?.unit,  // Keep this for dependency but don't use in API call
    loading
  ]);

  useEffect(() => {
    const calculateTotalDimensions = () => {
      // Use conversion functions for accurate calculations
      const totalWeight = formData.dimensions.reduce((sum, dim) => {
        const weightInKg = getWeightInKg(dim.weight);
        const quantity = parseFloat(dim.quantity.value || 0);
        return sum + (weightInKg * quantity);
      }, 0);

      const totalLength = formData.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.length);
      }, 0);

      const totalWidth = formData.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.width);
      }, 0);

      const totalHeight = formData.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.height);
      }, 0);

      setTotalDimensionsWeight(totalWeight);
      setTotalDimensionsLength(totalLength);
      setTotalDimensionsWidth(totalWidth);
      setTotalDimensionsHeight(totalHeight);
    };

    calculateTotalDimensions();
  }, [formData.dimensions]);

  useEffect(() => {
    const calculateTotalValue = () => {
      // Get user currency and items currency
      const userCurrency = user.currency || "EUR";
      const itemsCurrency = formData.itemsCurrency || "USD";

      // Calculate total value in items currency first
      const totalInItemsCurrency = formData.items.reduce((sum, item) => {
        const value = parseFloat(item.itemValue) || 0;
        const quantity = parseFloat(item.quantity) || 0;
        return sum + (value * quantity);
      }, 0);

      const totalQuantity = formData.items.reduce((sum, item) => {
        const quantity = parseFloat(item.quantity) || 0;
        return sum + quantity;
      }, 0);

      // If currencies are the same, no conversion needed
      if (userCurrency === itemsCurrency) {
        setTotalItemsValue(totalInItemsCurrency);
        setItemsTotalQty(totalQuantity);
        return;
      }

      // Find conversion rate from itemsCurrency to userCurrency
      let conversionRate = 1;

      // Find the currency data for items currency
      const itemsCurrencyData = currencies.find(curr => curr.name === itemsCurrency);

      if (itemsCurrencyData && itemsCurrencyData.exchangeRates && itemsCurrencyData.exchangeRates[userCurrency]) {
        // Direct conversion available from itemsCurrency to userCurrency
        conversionRate = itemsCurrencyData.exchangeRates[userCurrency];
      } else {
        // Try reverse conversion: find userCurrency data and get rate to itemsCurrency
        const userCurrencyData = currencies.find(curr => curr.name === userCurrency);

        if (userCurrencyData && userCurrencyData.exchangeRates && userCurrencyData.exchangeRates[itemsCurrency]) {
          // Reverse the rate: if 1 EUR = 1.16 USD, then 1 USD = 1/1.16 EUR
          conversionRate = 1 / userCurrencyData.exchangeRates[itemsCurrency];
        } else {
          // Fallback: try cross-conversion through USD if neither direct conversion exists
          const itemsToUSD = itemsCurrencyData?.exchangeRates?.USD || 1;
          const userCurrencyData = currencies.find(curr => curr.name === userCurrency);
          const USDToUserCurrency = userCurrencyData?.exchangeRates?.USD ? (1 / userCurrencyData.exchangeRates.USD) : 1;

          conversionRate = itemsToUSD * USDToUserCurrency;
        }
      }

      // Apply conversion: convert from itemsCurrency to userCurrency
      const totalInUserCurrency = totalInItemsCurrency * conversionRate;

      setTotalItemsValue(totalInUserCurrency);
      setItemsTotalQty(totalQuantity);
    };

    calculateTotalValue();
  }, [formData.items, user.currency, formData.itemsCurrency, currencies]);

  useEffect(() => {
    const calculateTotalQuantity = () => {
      const total = formData.dimensions.reduce((sum, dim) => {
        return sum + (parseFloat(dim.quantity.value) || 0);
      }, 0);
      setTotalItemsQuantity(total);
    };

    calculateTotalQuantity();
  }, [formData.dimensions]);

  useEffect(() => {
    const calculateInsurance = () => {
      const calculatedInsurance = formData.insuranceSelected === 'YES' ? totalItemsValue * 0.0075 : 0;
      setInsurance(calculatedInsurance);
    };

    calculateInsurance();
  }, [formData.insuranceSelected, totalItemsValue]);

  // New useEffect for COLLECTION
  useEffect(() => {
    if (formData.selectedTemplate && formData.selectedTemplate.services) {
      const collectionService = formData.selectedTemplate.services.find(
        service => service.description.toUpperCase() === 'COLLECTION'
      );
      if (collectionService) {
        const calculatedCollection = calculateServiceValue(
          collectionService,
          formData,
          calculatedValues,
          totalItemsValue,
          totalDimensionsWeight,
          totalDimensionsLength,
          totalDimensionsWidth,
          totalDimensionsHeight,
          0,
          insurance,
          totalItemsQuantity,
          itemsTotalQty
        );
        setCollectionValue(calculatedCollection);
      } else {
        setCollectionValue(0);
      }
    }
  }, [
    formData.selectedTemplate,
    formData,
    calculatedValues,
    totalItemsValue,
    totalDimensionsWeight,
    totalDimensionsLength,
    totalDimensionsWidth,
    totalDimensionsHeight,
    insurance,
    totalItemsQuantity,
    itemsTotalQty
  ]);

  useEffect(() => {
    const calculateAirfreightCost = () => {
      // Use converted dimensions in CM for volumetric weight calculation
      const totalVolumetricWeight = formData.dimensions.reduce((sum, dim) => {
        const lengthCm = getDimensionInCm(dim.length);
        const widthCm = getDimensionInCm(dim.width);
        const heightCm = getDimensionInCm(dim.height);
        const quantity = parseFloat(dim.quantity.value || 0);

        let volWeight = (lengthCm * widthCm * heightCm) / 6000;
        return sum + (volWeight * quantity);
      }, 0);

      // Take the maximum between volumetric weight and actual weight (both in kg)
      const chargeableWeight = Math.max(totalVolumetricWeight, totalDimensionsWeight);

      let airfreightCost;
      if (chargeableWeight < 360) {
        airfreightCost = 6.50 * chargeableWeight + 250;
      } else if (chargeableWeight >= 360 && chargeableWeight <= 1080) {
        airfreightCost = 5.00 * chargeableWeight + 250;
      } else {
        airfreightCost = 4.00 * chargeableWeight + 250;
      }

      setAirfreight(airfreightCost);
    };

    calculateAirfreightCost();
  }, [formData.dimensions, totalDimensionsWeight]);

  useEffect(() => {
    if (formData.selectedTemplate && formData.selectedTemplate.services) {
      const newCalculatedValues = {};
      formData.selectedTemplate.services.forEach((service) => {
        newCalculatedValues[service.description] = calculateServiceValue(
          service,
          formData,
          newCalculatedValues,
          totalItemsValue,
          totalDimensionsWeight,
          totalDimensionsLength,
          totalDimensionsWidth,
          totalDimensionsHeight,
          cif,
          insurance,
          totalItemsQuantity,
          itemsTotalQty
        );
      });
      setCalculatedValues(newCalculatedValues);

      const updatedSummary = {
        total: Object.values(newCalculatedValues).reduce((sum, value) => sum + value, 0),
        currency: user.currency || "USD", // Changed to use user.currency
        services: formData.selectedTemplate.services.map((service) => ({
          description: service.description,
          value: newCalculatedValues[service.description] || 0,
        })),
      };
      setEstimateSummary(updatedSummary);
    } else {
      setCalculatedValues({});
      setEstimateSummary(null);
    }
  }, [formData, adminEstimate, cif, insurance, totalItemsQuantity, itemsTotalQty, totalDimensionsWeight, totalDimensionsLength, totalDimensionsWidth, totalDimensionsHeight, totalItemsValue]);

  const handleInputChange = (e) => {
    const { name, value } = e.target || e;
    setFormData((prevData) => {
      let newValue = value;
      if (name === "selectedService") {
        newValue = value === "IOR&EOR" ? "EOR & IOR" : value;
        return {
          ...prevData,
          [name]: newValue,
          eccnCode: newValue === "EOR" ? prevData.eccnCode : null,
          requiredDoc: newValue === "EOR" ? "not_Required" : prevData.requiredDoc
        };
      }
      const newData = { ...prevData, [name]: newValue };
      if (name === "originCountry" && !needsStateSelection(value)) {
        newData.originState = "";
      }
      if (name === "destinationCountry" && !needsStateSelection(value)) {
        newData.destinationState = "";
      }
      return newData;
    });

    setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
  };

  const handleUnitChange = (field, e) => {
    const { value } = e.target;
    if (field === "height") {
      setFormData((prevData) => ({
        ...prevData,
        height: { ...prevData.height, unit: value },
        length: { ...prevData.length, unit: value },
        width: { ...prevData.width, unit: value },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: {
          ...prevData[field],
          unit: value,
        },
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    const isEmpty = (value) => {
      if (value === null || value === undefined) return true;
      if (typeof value === "string") return value.trim() === "";
      if (typeof value === "number") return isNaN(value) || value === 0;
      return false;
    };

    formData.dimensions.forEach((dimension, index) => {
      ['weight', 'length', 'width', 'height', 'quantity'].forEach(field => {
        if (isEmpty(dimension[field]?.value)) {
          newErrors[`${field}-${index}`] = true;
          hasErrors = true;
        }
      });
    });

    const isValidHSCode = (code) => {
      return /^\d{6,}$/.test(code);
    };

    const fieldsToValidate = [
      "destinationCity",
      "originCity",
      "originCountry",
      "destinationCountry",
    ];

    // Only validate requiredDoc if service isn't EOR
    if (formData.selectedService !== "EOR") {
      fieldsToValidate.push("requiredDoc");
    }

    if ((formData.selectedService === "EOR" || formData.selectedService === "EOR & IOR") && isEmpty(formData.eccnCode)) {
      newErrors["eccnCode"] = true;
      hasErrors = true;
    }

    if (needsStateSelection(formData.originCountry) && isEmpty(formData.originState)) {
      newErrors["originState"] = true;
      hasErrors = true;
    }
    if (needsStateSelection(formData.destinationCountry) && isEmpty(formData.destinationState)) {
      newErrors["destinationState"] = true;
      hasErrors = true;
    }

    for (const key of fieldsToValidate) {
      const value = formData[key];

      if (typeof value === "object" && value !== null) {
        if (isEmpty(value.value)) {
          newErrors[key] = true;
          hasErrors = true;
        }
      } else if (isEmpty(value)) {
        newErrors[key] = true;
        hasErrors = true;
      }
    }

    if (formData.items.length === 0) {
      newErrors.items = "At least one item is required.";
      hasErrors = true;
    } else {
      formData.items.forEach((item, index) => {
        [
          "itemName",
          "quantity",
          "itemValue",
          "countryOrigin",
          "hasHSCode",
          "itemNew",
        ].forEach((field) => {
          if (isEmpty(item[field])) {
            newErrors[`${field}-${index}`] = true;
            hasErrors = true;
          }
          if (isEmpty(item.countryOrigin)) {
            newErrors[`countryOrigin-${index}`] = true;
            hasErrors = true;
          }
        });

        if (item.hasHSCode === true) {
          if (isEmpty(item.itemHSCode)) {
            newErrors[`itemHSCode-${index}`] = true;
            hasErrors = true;
          } else {
            // Enhanced validation for manual entry
            if (item.hsCodeSource === 'manual') {
              const hsCode = item.itemHSCode.toString();
              if (hsCode.length < 6) {
                newErrors[`itemHSCode-${index}`] = "HS Code must be at least 6 characters long.";
                hasErrors = true;
              } else {
                const first6 = hsCode.substring(0, 6);
                if (!/^\d{6}$/.test(first6)) {
                  newErrors[`itemHSCode-${index}`] = "First 6 digits of HS Code must be numbers only.";
                  hasErrors = true;
                }
              }
            } else {
              // Database validation (existing logic)
              if (!isValidHSCode(item.itemHSCode)) {
                newErrors[`itemHSCode-${index}`] = "HS Code must be at least 6 digits long.";
                hasErrors = true;
              }
            }
          }
        }
      });
    }

    setErrors(newErrors);
    return hasErrors;
  };

  useEffect(() => {
    if (estimate && estimate.estimateSummary) {
      setEstimateSummary(estimate.estimateSummary);
      setShowEstimateResults(true);
    }
  }, [estimate]);

  const handleGetEstimate = async () => {
    if (buttonText === "Proceed") {
      onBack();
      return;
    }

    const hasErrors = validateForm();
    if (hasErrors) {
      toast.error("Please fill all mandatory fields.");
      return;
    }

    // Check for restricted ECCN code
    if ((formData.selectedService === "EOR" || formData.selectedService === "EOR & IOR") && formData.eccnCode) {
      const selectedEccnObj = eccnCodes.find(eccn => eccn.eccn_code === formData.eccnCode);
      if (selectedEccnObj && selectedEccnObj.restrictions) {
        setWarningPopup({
          isOpen: true,
          message: "The selected ECCN code is restricted. You must fill out a manual form. Please contact our team at operations@oneunionsolutions.com for assistance."
        });
        return;
      }
    }

    const hasInvalidHSCode = formData.items.some((item) => item.hasHSCode === false);
    const hasNonNewItem = formData.items.some((item) => item.itemNew === false);

    if (hasInvalidHSCode) {
      setWarningPopup({
        isOpen: true,
        message: "We only accept items with HS code. Please contact our team through operations@oneunionsolutions.com with your request for used items shipments."
      });
      return;
    }

    if (hasNonNewItem) {
      toast.error("Please ensure that all items are new.");
      return;
    }

    const userCurrency = user.currency || "EUR";
    const currencyData = currencies.find(curr => curr.name === userCurrency) || { name: "EUR", exchangeRateUSD: 1.07 };
    const exchangeRateUSD = currencyData.exchangeRateUSD || 1;

    setLoading(true);

    try {

      const isDisabled = disabledCountries.some(country =>
        country.countryName.toLowerCase() === formData.destinationCountry.toLowerCase()
      );
      if (isDisabled) {
        setWarningPopup({
          isOpen: true,
          message: `Currently Estimation not Available for ${formData.destinationCountry}. Please contact our team through operations@oneunionsolutions.com with your request or fill the form manually.`
        });
        return;
      }

      await fetchAdminEstimate(
        formData.originCountry,
        formData.destinationCountry,
        formData.selectedService,
        formData.itemsCurrency,
        "kg"  // Always pass "kg" instead of form weight unit
      );

      // Check if admin estimate exists
      if (!adminEstimate) {
        setWarningPopup({
          isOpen: true,
          message: `Estimation not found for ${formData.destinationCountry}. Please contact our team through operations@oneunionsolutions.com with your request or fill the form manually.`,
          confirmText: "Fill Manually",
          onConfirm: () => {
            // Optional: Add logic to pre-fill or enable manual form fields
            setWarningPopup({ isOpen: false, message: "" });
            // You might want to add additional logic here to enable manual editing
          }
        });
        return;
      }

      const isDutyVatDisabled = disabledDutyVatCountries.some(country =>
        country.countryName.toLowerCase() === formData.destinationCountry.toLowerCase()
      );

      let dhlData = null;
      let dutyValue = 0;
      if (formData.selectedService !== "EOR" && !isDutyVatDisabled) {
        const result = await getDHLEstimation(formData.items);
        if (!result) throw new Error("No data returned");
        dhlData = result.dhlData;
        dutyValue = result.dutyValue;
      }

      // Set states regardless of DHL call
      setDuty(dutyValue);
      const calculatedInsurance = formData.insuranceSelected === 'YES' ? (totalItemsValue * 0.0075) : 0;
      setInsurance(calculatedInsurance);

      // Use converted dimensions for volumetric weight calculation
      const totalVolumetricWeight = formData.dimensions.reduce((sum, dim) => {
        const lengthCm = getDimensionInCm(dim.length);
        const widthCm = getDimensionInCm(dim.width);
        const heightCm = getDimensionInCm(dim.height);
        const quantity = parseFloat(dim.quantity.value || 0);

        let volWeight = (lengthCm * widthCm * heightCm) / 6000;
        return sum + (volWeight * quantity);
      }, 0);

      // Take the maximum between volumetric weight and actual weight (both in kg)
      const chargeableWeight = Math.max(totalVolumetricWeight, totalDimensionsWeight);

      let airfreightCost;
      if (chargeableWeight < 360) {
        airfreightCost = 6.50 * chargeableWeight + 250;
      } else if (chargeableWeight >= 360 && chargeableWeight <= 1080) {
        airfreightCost = 5.00 * chargeableWeight + 250;
      } else {
        airfreightCost = 4.00 * chargeableWeight + 250;
      }

      setAirfreight(airfreightCost);

      const calculatedCIF = (
        parseFloat(totalItemsValue || 0) +
        parseFloat(airfreightCost || 0) +
        parseFloat(calculatedInsurance || 0) +
        parseFloat(dutyValue || 0) +
        parseFloat(collectionValue || 0)
      );
      setCif(calculatedCIF);

      let dhlTaxes = [];
      let dhlTaxTotal = 0;
      const specialVATCountries = ['CM', 'HN', 'MD', 'NA', 'SZ', 'EC', 'SC', 'LR', 'IL', 'LB', 'MW', 'GR'];
      const taxConfigs = {
        CM: { rate: 0.175, type: 'VAT' },
        HN: { rate: 0.150, type: 'SALE' },
        SZ: { rate: 0.150, type: 'VAT' },
        EC: { rate: 0.150, type: 'VAT' },
        MD: { rate: 0.200, type: 'VAT' },
        SC: { rate: 0.150, type: 'VAT' },
        LR: { rate: 0.100, type: 'GST' },
        NA: { rate: 0.15, type: 'VAT' },
        IL: { rate: 0.180, type: 'VAT' },
        LB: { rate: 0.110, type: 'VAT' },
        MW: { rate: 0.165, type: 'VAT' },
        GR: { rate: 0.240, type: 'VAT' },
      };

      const calculateSpecialTax = (dutyAmount, CIF, countryCode, totalItemsValue) => {
        const config = taxConfigs[countryCode];
        if (!config) return 0;

        if (countryCode === 'GR') return config.rate * (CIF + dutyAmount);
        if (countryCode === 'LB') {
          const addyFee = dhlData?.feeTotals.find(fee => fee.name === 'ADDY')?.value || 0;
          return config.rate * (dutyAmount + CIF + addyFee);
        }
        if (countryCode === 'NA') return (config.rate * totalItemsValue) * 1.1;
        if (countryCode === 'EC') {
          const relevantFees = ['DUTY', 'FODINFA', 'ICE', 'SAFEGUARD'];
          const feesTotal = dhlData?.feeTotals
            .filter(fee => relevantFees.includes(fee.name))
            .reduce((sum, fee) => sum + fee.value, 0) || 0;
          return config.rate * (totalItemsValue + feesTotal);
        }
        if (countryCode === 'SZ') return config.rate * (totalItemsValue + dutyAmount);
        if (countryCode === 'LR') {
          const ecowasLevy = dhlData?.feeTotals.find(fee => fee.name === 'ECOWAS_TRADE_LEVY')?.value || 0;
          return config.rate * (CIF + dutyAmount + ecowasLevy);
        }
        if (countryCode === 'MW') return config.rate * (dutyAmount + CIF);
        return config.rate * (dutyAmount + CIF);
      };

      if (formData.selectedService !== "EOR" && dhlData && calculatedCIF !== undefined) {
        const CIF = calculatedCIF;
        const specificTaxes = ['DUTY', 'VAT', 'SALE', 'GST'];
        const mainTaxes = {};
        const otherTaxes = [];
        let otherTaxesTotal = 0;
        const countryCode = dhlData.consigneeAddress?.country;
        const itemHsCode = dhlData.customsDetails?.[0]?.hsCode;

        dhlData.feeTotals.forEach((fee) => {
          if (fee.value <= 0) return;

          if (countryCode === 'LB' && fee.name === 'ACD') return;
          const shouldSkipExcise = countryCode === 'MW' && itemHsCode && itemHsCode.startsWith('85');
          if (fee.name === 'EXCISE' && shouldSkipExcise ||
            (countryCode === 'EC' && fee.name === 'SPCT') ||
            (countryCode === 'DO' && fee.name === 'CONS') ||
            (countryCode === 'ET' && fee.name === 'SWL') ||
            (countryCode === 'IL' && fee.name === 'TAMA')) return;

          if (specificTaxes.includes(fee.name)) {
            if (specialVATCountries.includes(countryCode) &&
              (fee.name === 'VAT' || fee.name === 'SALE' || fee.name === 'GST')) {
              const dutyAmount = dhlData.feeTotals.find(f => f.name === 'DUTY')?.value || 0;
              fee.value = calculateSpecialTax(dutyAmount, CIF, countryCode, totalItemsValue);
            }
            if (fee.value > 0) {
              mainTaxes[fee.name] = {
                name: fee.name === 'SALE' || fee.name === 'GST' ? `VAT (${fee.name})` : fee.name,
                value: fee.value
              };
            }
          } else {
            if (countryCode === 'AU' && fee.name === 'IMPROC') fee.value = CIF * 0.012;
            if (fee.value > 0) {
              otherTaxes.push(fee);
              otherTaxesTotal += fee.value;
            }
          }
        });

        if (countryCode === 'QA' && !otherTaxes.some(tax => tax.name === 'EXTRA_TAX')) {
          const extraTaxValue = 400;
          if (extraTaxValue > 0) {
            otherTaxes.push({ name: 'EXTRA_TAX', value: extraTaxValue });
            otherTaxesTotal += extraTaxValue;
          }
        }

        if (countryCode === 'TR' && !otherTaxes.some(tax => tax.name === 'EXTRA_TAX') &&
          itemHsCode && itemHsCode.startsWith('8')) {
          const extraTaxValue = CIF * 0.05;
          if (extraTaxValue > 0) {
            otherTaxes.push({ name: 'EXTRA_TAX', value: extraTaxValue });
            otherTaxesTotal += extraTaxValue;
          }
        }

        if (countryCode === 'AU' && !otherTaxes.some(tax => tax.name === 'IMPROC')) {
          const improcValue = CIF * 0.012;
          if (improcValue > 0) {
            otherTaxes.push({ name: 'IMPROC', value: improcValue });
            otherTaxesTotal += improcValue;
          }
        }

        if (countryCode === 'KM' && !otherTaxes.some(tax => tax.name === 'ICF')) {
          const icfValue = CIF * 0.025;
          if (icfValue > 0) {
            otherTaxes.push({ name: 'ICF', value: icfValue });
            otherTaxesTotal += icfValue;
          }
        }

        if (countryCode === 'CR' && !otherTaxes.some(tax => tax.name === 'LAW')) {
          const lawValue = CIF * 0.01;
          if (lawValue > 0) {
            otherTaxes.push({ name: 'LAW', value: lawValue });
            otherTaxesTotal += lawValue;
          }
        }

        if (countryCode === 'CI' && !otherTaxes.some(tax => tax.name === 'EXTRA_TAX')) {
          const extraTaxValue = Math.max(CIF * 0.05, 300);
          if (extraTaxValue > 0) {
            otherTaxes.push({ name: 'EXTRA_TAX', value: extraTaxValue });
            otherTaxesTotal += extraTaxValue;
          }
        }

        if (countryCode === 'LB' && !otherTaxes.some(tax => tax.name === 'EXTRA_TAX')) {
          const extraTaxValue = 350;
          if (extraTaxValue > 0) {
            otherTaxes.push({ name: 'EXTRA_TAX', value: extraTaxValue });
            otherTaxesTotal += extraTaxValue;
          }
        }

        if (countryCode === 'NA' && !mainTaxes['VAT']) {
          const dutyAmount = dhlData.feeTotals.find(f => f.name === 'DUTY')?.value || 0;
          const vatValue = calculateSpecialTax(dutyAmount, CIF, countryCode, totalItemsValue);
          if (vatValue > 0) mainTaxes['VAT'] = { name: 'VAT', value: vatValue };
        }

        if (countryCode === 'MW' && !mainTaxes['VAT']) {
          const dutyAmount = dhlData.feeTotals.find(f => f.name === 'DUTY')?.value || 0;
          const vatValue = calculateSpecialTax(dutyAmount, CIF, countryCode, totalItemsValue);
          if (vatValue > 0) mainTaxes['VAT'] = { name: 'VAT', value: vatValue };
        }

        specificTaxes.forEach(taxName => {
          if (mainTaxes[taxName] && mainTaxes[taxName].value > 0) {
            dhlTaxes.push(mainTaxes[taxName]);
            dhlTaxTotal += mainTaxes[taxName].value;
          }
        });

        if (otherTaxes.length > 0) {
          dhlTaxes.push({ name: 'Taxes', value: otherTaxesTotal, details: otherTaxes });
          dhlTaxTotal += otherTaxesTotal;
        }
      }

      // Calculate service values with updated CIF
      const newCalculatedValues = {};
      if (formData.selectedTemplate && formData.selectedTemplate.services) {
        formData.selectedTemplate.services.forEach((service) => {
          newCalculatedValues[service.description] = calculateServiceValue(
            service,
            formData,
            newCalculatedValues,
            totalItemsValue,
            totalDimensionsWeight,
            totalDimensionsLength,
            totalDimensionsWidth,
            totalDimensionsHeight,
            calculatedCIF,
            calculatedInsurance,
            totalItemsQuantity,
            itemsTotalQty
          );
        });
      }
      setCalculatedValues(newCalculatedValues);

      const serviceTotal = Object.values(newCalculatedValues).reduce((sum, value) => sum + (parseFloat(value) || 0), 0);
      const estimateTotal = serviceTotal + parseFloat(dhlTaxTotal || 0);

      setDhlEstimation(dhlData);

      const estimateData = {
        originCity: formData.originCity,
        destinationCity: formData.destinationCity,
        originState: formData.originState,
        destinationState: formData.destinationState,
        dimensions: formData.dimensions.map(dimension => ({
          weight: dimension.weight,
          length: dimension.length,
          width: dimension.width,
          height: dimension.height,
          quantity: dimension.quantity
        })),
        originCountry: formData.originCountry,
        destinationCountry: formData.destinationCountry,
        userId: formData.userId,
        userName: formData.userName,
        userCity: formData.userCity,
        userCountry: formData.userCountry,
        postalCode: formData.postalCode,
        email: formData.email,
        itemsCurrency: formData.itemsCurrency,
        selectedService: formData.selectedService,
        eccnCode: formData.eccnCode,
        insuranceSelected: formData.insuranceSelected,
        requiredDoc: formData.requiredDoc,
        items: formData.items.map((item) => ({
          itemName: item.itemName,
          itemHSCode: item.itemHSCode,
          itemValue: item.itemValue,
          countryOrigin: item.countryOrigin,
          quantity: item.quantity,
          hasHSCode: item.hasHSCode,
          itemNew: item.itemNew,
        })),
        estimationAccept: false,
        dhlEstimation: dhlData,
        estimateSummary:
          formData.selectedTemplate && formData.selectedTemplate.services
            ? {
              total: estimateTotal,
              currency: user.currency || "USD", // Changed to use user.currency
              services: formData.selectedTemplate.services.map((service) => ({
                description: service.description,
                value: newCalculatedValues[service.description] || 0,
              })),
              dhlTaxes: dhlTaxes
            }
            : {
              total: parseFloat(dhlTaxTotal || 0),
              currency: user.currency || "USD", // Changed to use user.currency for consistency
              services: [],
              dhlTaxes: dhlTaxes
            },
      };

      estimateData.countryCodes = `${getAlpha2Code(formData.originCountry)}-${getAlpha2Code(formData.destinationCountry)}`;

      const adminsPromise = getAllSuperAdminUsers();
      let response;
      let estimateId;
      if (!isNewEstimate && estimate) {
        estimateData.estimationAccept = false;
        response = await api.put(`${API_BASE_URL}/clientestimates/id/${estimate.estimateId}`, estimateData);
        estimateId = estimate.estimateId;
      } else {
        response = await api.post(`${API_BASE_URL}/clientestimates`, estimateData);
        estimateId = response.data.data.estimateId;
      }

      const summaryPromise = api.get(`${API_BASE_URL}/clientestimates/summary/${estimateId}`);
      const notificationPromise = createAdminNotification(estimateData, estimateId, !isNewEstimate && !!estimate);
      const [summaryResponse, admins] = await Promise.all([summaryPromise, adminsPromise, notificationPromise]);

      const newSummary = summaryResponse.data.estimateSummary;
      setEstimateSummary(newSummary);
      setClientEstimateSummary(newSummary);

      const adminEmails = admins.map((admin) => admin.email);
      const link = `${API_DEPLOYED_URL}/estimated-ior/${estimateId}`;
      await api.post(`${API_BASE_URL}/mail/estimate-notification`, {
        estimateData,
        isUpdate: !!estimate,
        adminEmails,
        link,
      });

      fetchEstimates();
      setIsModalOpen(true);
      setIsReadOnly(true);
      setButtonText("Proceed");
      setShowEstimateResults(true);

      if (isHSCodeRelated || !formData.selectedTemplate || !formData.selectedTemplate.services) {
        setFormData(prevData => ({ ...prevData, status: false }));
      }
    } catch (error) {
      console.error("Error creating estimate:", error);
      toast.error(`Failed to submit estimate request: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const getInputClassName = (fieldName) => {
    return `w-full h-8 p-2 text-sm border rounded-md outline-none ${errors[fieldName]
      ? "border-red-500 "
      : "active:border-cus-blue focus:border-cus-blue"
      }`;
  };

  const getSelectClassName = (fieldName) => {
    return errors[fieldName] ? "border-red-500" : "";
  };

  const createAdminNotification = async (
    estimateData,
    estimateId,
    isUpdate = false
  ) => {
    try {
      const itemNames = formData.items.map(item => item.itemName);
      const formattedItemNames = itemNames.join(', ');
      const notificationData = {
        title: isUpdate ? "Estimate Update Request" : "New Estimate Request",
        message: `${user.name} has ${isUpdate ? "updated an" : "requested a new"} estimate for ${formattedItemNames}`,
        type: isUpdate ? "update-estimate" : "new-estimate",
        link: `/estimated-ior/${estimateId}`,
        linkText: "View Estimate",
        role: "admin",
      };

      return api.post(`${API_BASE_URL}/notifications`, notificationData);
    } catch (error) {
      console.error("Error creating admin notification:", error);
    }
  };

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "30px",
      borderRadius: "12px",
      maxWidth: "500px",
      width: "90%",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
      border: "none",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
  };

  const handleAddMore = () => {
    setFormData((prevData) => ({
      ...prevData,
      items: [...prevData.items, {
        itemName: "",
        itemHSCode: "",
        itemValue: "",
        countryOrigin: "",
        quantity: "",
        hasHSCode: null,
        itemNew: true,
        hsCodeSource: "database",
      }],
    }));
  };

  const handleRemoveService = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      items: prevData.items.filter((_, i) => i !== index),
    }));
  };

  const handleServiceInputChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const updated = [...prevData.items];
      if (field === "item-quantity") {
        const f = field.split("-");
        updated[index][f[1]] = value;
      } else if (field === "hasHSCode") {
        updated[index].hasHSCode = value === "yes";
        if (value === "no") {
          updated[index].itemHSCode = "";
        }
      } else if (field === "itemNew") {
        updated[index].itemNew = value === "yes";
      } else {
        updated[index][field] = value;
      }

      return {
        ...prevData,
        items: updated,
      };
    });
  };

  const handleAntdServiceInputChange = (index, field, value) => {
    setFormData((prevData) => {
      const updated = [...prevData.items];
      updated[index][field] = value;

      return {
        ...prevData,
        items: updated,
      };
    });
  };

  const loadHSCodeOptions = useCallback(async (inputValue) => {
    if (inputValue.length < 6 || !formData.destinationCountry) {
      return [];
    }
    try {
      const response = await api.get(`/hscodes?country=${formData.destinationCountry}&prefix=${inputValue.slice(0, 6)}`);
      return response.data.map(item => ({
        value: item.HS,
        label: `${item.HS} - ${item.HS4Desc} - ${item.HS6Desc}`
      }));
    } catch (error) {
      console.error('Error fetching HS codes:', error);
      return [];
    }
  }, [formData.destinationCountry]);

  useEffect(() => {
    if (formData.selectedTemplate && formData.selectedTemplate.services) {
      const hasHSCodeFormula = formData.selectedTemplate.services.some(
        (service) =>
          service.values &&
          (service.values.includes("HSCode Count") ||
            service.values.includes("HSCode Starts with"))
      );
      setIsHSCodeRelated(hasHSCodeFormula);
    }
  }, [formData.selectedTemplate]);

  const getDHLToken = async () => {
    try {
      const response = await fetch('https://api.dhl.com/auth/v1/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          grant_type: 'client_credentials',
          response_type: 'access_token',
          client_id: '7E2HCWQVR0A10NJKYbYnxRt5uFT7vn1z',
          client_secret: 'uB26UUKHmBMJqbMQ'
        })
      });

      if (!response.ok) {
        throw new Error('Failed to get access token');
      }

      const data = await response.json();
      setAccessToken(data.access_token);
      setTokenExpiry(Date.now() + (15 * 60 * 1000));
      return data.access_token;
    } catch (error) {
      console.error('Error getting DHL token:', error);
      toast.error('Failed to authenticate with DHL');
      return null;
    }
  };

  const ensureValidToken = useCallback(async () => {
    if (!accessToken || !tokenExpiry || Date.now() >= tokenExpiry) {
      return await getDHLToken();
    }
    return accessToken;
  }, [accessToken, tokenExpiry]);

  const getCountryCode = (countryInput) => {
    if (!countryInput) return null;

    if (Array.isArray(countryInput)) {
      if (countryInput.length === 0) return null;
      return getAlpha2Code(countryInput[0]);
    }

    if (typeof countryInput === 'string') {
      return getAlpha2Code(countryInput);
    }

    return null;
  };

  useEffect(() => {
    if (formData) {
      if (needsStateSelection(formData.originCountry) && !senderState) {
        setSenderState(formData.originState || formData.originCity || '');
      }

      if (needsStateSelection(formData.destinationCountry) && !receiverState) {
        setReceiverState(formData.destinationState || formData.destinationCity || '');
      }
    }
  }, [formData.originCountry, formData.destinationCountry, formData.originCity, formData.destinationCity, formData.originState, formData.destinationState]);

  const needsStateSelection = (country) => {
    const countryCode = getCountryCode(country);
    return countryCode === 'CA' || countryCode === 'BR';
  };

  const getAvailableStates = (country) => {
    const countryCode = getCountryCode(country);
    if (countryCode === 'CA') {
      return CANADIAN_PROVINCES.map(province => ({
        value: province.state,
        label: province.state
      }));
    }
    if (countryCode === 'BR') {
      return BRAZILIAN_STATES.map(state => ({
        value: state.state,
        label: state.state
      }));
    }
    return [];
  };

  const prepareDHLRequestBody = (formItems, dimensions) => {
    const senderCountry = getCountryCode(formData.originCountry) || '';
    const receiverCountry = getCountryCode(formData.destinationCountry) || '';

    // Get currencies
    const userCurrency = user.currency || "EUR";
    const itemsCurrency = formData.itemsCurrency || "USD";
    const dhlCurrency = userCurrency === "USD" ? "USD" : "EUR";

    // Helper function to convert any currency to DHL currency
    const convertToDHLCurrency = (amount, fromCurrency) => {
      if (fromCurrency === dhlCurrency) {
        return amount;
      }

      let conversionRate = 1;

      // Find conversion rate from fromCurrency to dhlCurrency
      const fromCurrencyData = currencies.find(curr => curr.name === fromCurrency);

      if (fromCurrencyData && fromCurrencyData.exchangeRates && fromCurrencyData.exchangeRates[dhlCurrency]) {
        conversionRate = fromCurrencyData.exchangeRates[dhlCurrency];
      } else {
        // Try reverse conversion
        const toCurrencyData = currencies.find(curr => curr.name === dhlCurrency);
        if (toCurrencyData && toCurrencyData.exchangeRates && toCurrencyData.exchangeRates[fromCurrency]) {
          conversionRate = 1 / toCurrencyData.exchangeRates[fromCurrency];
        }
      }

      return amount * conversionRate;
    };

    const requestBody = {
      pricingStrategy: pricingStrategy,
      senderAddress: {
        country: senderCountry,
        state: formData.originState || senderState || formData.originCity || ''
      },
      consigneeAddress: {
        country: receiverCountry,
        state: formData.destinationState || receiverState || formData.destinationCity || ''
      },
      packageDetails: {
        outputCurrency: dhlCurrency,
        transportMode: transportMode,
        endUse: "BUSINESS",
        clearanceMode: "COURIER",
        tax: {
          included: false,
          percent: 0,
          return: true
        },
        freightCharge: {
          value: /*parseFloat(airfreight) ||*/ 0,
          currency: dhlCurrency
        },
        insuranceCharge: {
          value: /*formData.insuranceSelected === 'YES' ? parseFloat(totalItemsValue * 0.0075) || 0 :*/ 0,
          currency: dhlCurrency
        }
      },
      customsDetails: formItems.map(item => {
        // Convert item value from itemsCurrency to dhlCurrency
        const itemValueInItemsCurrency = parseFloat(item.itemValue) || 0;
        const itemValueInDHLCurrency = convertToDHLCurrency(itemValueInItemsCurrency, itemsCurrency);

        return {
          itemId: `ITEM_${Math.random().toString(36).substr(2, 9)}`,
          itemDescription: item.itemName,
          hsCode: String(item.itemHSCode || ''),
          countryOfOrigin: getAlpha2Code(item.countryOrigin),
          itemQuantity: {
            value: parseInt(item.quantity),
            unit: "PCS"
          },
          itemValue: {
            value: itemValueInDHLCurrency * 1.1, // Increase by 10%
            currency: dhlCurrency
          },
          weight: {
            value: totalDimensionsWeight, // This is already in kg due to our conversion
            unit: "KG" // Always use KG for DHL API since totalDimensionsWeight is in kg
          },
        };
      })
    };

    return requestBody;
  };

  const filterDHLResponse = (dhlResponse) => {
    if (!dhlResponse) return null;

    const filteredFeeTotals = dhlResponse.feeTotals.filter(fee => fee.value > 0);

    return {
      quoteId: dhlResponse.quoteId,
      pricingStrategy: dhlResponse.pricingStrategy,
      feeTotals: filteredFeeTotals,
      consigneeAddress: dhlResponse.consigneeAddress,
      senderAddress: dhlResponse.senderAddress,
      packageDetails: {
        outputCurrency: dhlResponse.packageDetails.outputCurrency,
        clearanceMode: dhlResponse.packageDetails.clearanceMode,
        transportMode: dhlResponse.packageDetails.transportMode,
        endUse: dhlResponse.packageDetails.endUse,
        freightCharge: dhlResponse.packageDetails.freightCharge,
        insuranceCharge: dhlResponse.packageDetails.insuranceCharge,
      }
    };
  };

  const getDHLEstimation = async (items) => {
    const token = await ensureValidToken();
    if (!token) return null;

    try {
      const requestBody = prepareDHLRequestBody(items, formData.dimensions);

      const response = await fetch('https://api.dhl.com/dtc/v1/quotes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('DHL API Error:', errorData);

        if (errorData.type?.includes('400.0904002')) {
          setPricingStrategy('MAXIMUM');
          const retryBody = { ...requestBody, pricingStrategy: 'MAXIMUM' };
          const retryResponse = await fetch('https://api.dhl.com/dtc/v1/quotes', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(retryBody)
          });

          if (!retryResponse.ok) {
            throw new Error('Failed to get estimation even with MAXIMUM pricing strategy');
          }

          const retryData = await retryResponse.json();
          const filteredRetryData = filterDHLResponse(retryData);
          const dutyValue = retryData.feeTotals.find(fee => fee.name === 'DUTY')?.value || 0;
          setDuty(dutyValue);
          setDhlEstimation(filteredRetryData);
          return { dhlData: filteredRetryData, dutyValue };
        }

        throw new Error(errorData.message || 'Failed to get estimation');
      }

      const data = await response.json();
      const filteredData = filterDHLResponse(data);
      const dutyValue = data.feeTotals.find(fee => fee.name === 'DUTY')?.value || 0;
      setDuty(dutyValue);
      setDhlEstimation(filteredData);
      return { dhlData: filteredData, dutyValue };
    } catch (error) {
      console.error('Error getting estimation:', error);
      toast.error('Failed to get estimation: ' + error.message);
      return null;
    }
  };

  const renderEstimateSummary = () => {
    return (
      <EstimateSummaryWithDHL
        clientEstimateSummary={clientEstimateSummary}
        dhlEstimation={dhlEstimation}
        cif={cif}
        totalItemsValue={totalItemsValue}
        formData={formData}
        showEstimateResults={showEstimateResults}
        isHSCodeRelated={isHSCodeRelated}
        userCurrency={user.currency}
      />
    );
  };

  return (
    <>
      <div className="flex-1 bg-blue-50 p-6">
        <div className="max-w-1xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-6">
      <div>
          {shouldShowBackButton() && (
            <div className="mb-3 p-4">
              <button
                type="button"
                onClick={onBack}
                className="flex rounded-[5px] items-center space-x-4 py-2 px-4 text-white btnBg"
              >
                <FaArrowLeft className="mr-2" /> Back
              </button>
            </div>
          )}
        <div className="flex flex-col w-full bg-white">
          <div className="p-4">
            <div className="flex flex-col space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {["originCountry", "destinationCountry"].map((country) => (
                  <div key={country} className="flex flex-col gap-1">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={country}
                    >
                      {country === "originCountry"
                        ? "Origin Country"
                        : "Destination Country"}{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <CountrySelectInput
                      label=""
                      onChange={handleInputChange}
                      value={formData[country] || ""}
                      name={country}
                      id={country}
                      readOnly={isReadOnly}
                      className={`${getInputClassName(country)} !p-0`}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "2rem",
                          height: "2rem",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "2rem",
                          padding: "0 6px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0px",
                        }),
                      }}
                    />
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="originCity"
                  >
                    Origin City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={getInputClassName("originCity")}
                    id="originCity"
                    name="originCity"
                    onChange={handleInputChange}
                    value={formData.originCity || ""}
                    readOnly={isReadOnly}
                  />
                  {needsStateSelection(formData.originCountry) && (
                    <div className="mt-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor="originState"
                      >
                        Origin State <span className="text-red-500">*</span>
                      </label>
                      <Select
                        showSearch
                        id="originState"
                        className={getSelectClassName("originState")}
                        readOnly={isReadOnly}
                        options={getAvailableStates(formData.originCountry)}
                        onChange={(value) => handleInputChange({ target: { name: "originState", value } })}
                        value={formData.originState || ""}
                        style={{ width: "100%" }}
                      />
                      {errors["originState"] && (
                        <p className="text-red-500 text-xs mt-1">
                          Origin State is required
                        </p>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="destinationCity"
                  >
                    Destination City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={getInputClassName("destinationCity")}
                    id="destinationCity"
                    name="destinationCity"
                    onChange={handleInputChange}
                    value={formData.destinationCity || ""}
                    readOnly={isReadOnly}
                  />
                  {needsStateSelection(formData.destinationCountry) && (
                    <div className="mt-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor="destinationState"
                      >
                        Destination State <span className="text-red-500">*</span>
                      </label>
                      <Select
                        showSearch
                        id="destinationState"
                        className={getSelectClassName("destinationState")}
                        readOnly={isReadOnly}
                        options={getAvailableStates(formData.destinationCountry)}
                        onChange={(value) => handleInputChange({ target: { name: "destinationState", value } })}
                        value={formData.destinationState || ""}
                        style={{ width: "100%" }}
                      />
                      {errors["destinationState"] && (
                        <p className="text-red-500 text-xs mt-1">
                          Destination State is required
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Added Message Here */}
              <div
                className="bg-blue-50 border-l-4 border-blue-400 text-blue-700 p-3 mt-4 mb-4 rounded-md shadow-sm flex items-center"
                role="alert"
              >
                <span className="text-2xl mr-3" aria-hidden="true">✈️</span>
                <div>
                  <p className="font-semibold">Transport Mode Information</p>
                  <p>Currently, only Air Shipments are supported.</p>
                </div>
              </div>

              <div className="space-y-4">
                {formData.dimensions.map((dimension, index) => (
                  <div key={index} className="relative border p-4 rounded-md">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-2 md:gap-4">
                      <div className="flex flex-col gap-1">
                        <label className="w-full text-sm font-normal" htmlFor={`weight-${index}`}>
                          Weight <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="number"
                            className={`w-full md:w-24 p-1 text-sm border rounded-md outline-none ${errors[`weight-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                            name={`weight-value-${index}`}
                            id={`weight-${index}`}
                            readOnly={isReadOnly}
                            onChange={(e) => handleDimensionChange(index, 'weight', e)}
                            value={dimension.weight.value}
                            min="0"
                            step="0.01"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <select
                            className="ml-1 md:ml-2 p-1 text-sm border rounded-md outline-none w-auto"
                            name={`weight-unit-${index}`}
                            id={`weight-unit-${index}`}
                            readOnly={isReadOnly}
                            onChange={(e) => handleDimensionChange(index, 'weight', e)}
                            value={dimension.weight.unit}
                          >
                            <option value="kg">kg</option>
                            <option value="lbs">lbs</option>
                          </select>
                        </div>
                      </div>

                      {["length", "width", "height"].map((dim) => (
                        <div key={dim} className="flex flex-col gap-1">
                          <label className="w-full text-sm font-normal" htmlFor={`${dim}-${index}`}>
                            {dim.charAt(0).toUpperCase() + dim.slice(1)} <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center">
                            <input
                              type="number"
                              className={`w-full md:w-24 p-1 text-sm border rounded-md outline-none ${errors[`${dim}-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                              name={`${dim}-value-${index}`}
                              id={`${dim}-${index}`}
                              readOnly={isReadOnly}
                              onChange={(e) => handleDimensionChange(index, dim, e)}
                              value={dimension[dim].value}
                              min="0"
                              step="0.01"
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            {/* Show unit selector only for one dimension (height) to control all three */}
                            {dim === "height" && (
                              <select
                                className="ml-1 md:ml-2 p-1 text-sm border rounded-md outline-none w-auto"
                                name={`${dim}-unit-${index}`}
                                id={`${dim}-unit-${index}`}
                                readOnly={isReadOnly}
                                onChange={(e) => handleDimensionChange(index, dim, e)}
                                value={dimension[dim].unit}
                              >
                                <option value="cm">cm</option>
                                <option value="in">in</option>
                              </select>
                            )}

                          </div>
                        </div>
                      ))}

                      <div className="flex flex-col gap-1">
                        <label className="w-full text-sm font-normal" htmlFor={`quantity-${index}`}>
                          Quantity <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="number"
                            className={`w-full md:w-24 p-1 text-sm border rounded-md outline-none ${errors[`quantity-${index}`] ? "border-red-500" : "active:border-cus-blue focus:border-cus-blue"}`}
                            name={`quantity-value-${index}`}
                            id={`quantity-${index}`}
                            readOnly={isReadOnly}
                            onChange={(e) => handleDimensionChange(index, 'quantity', e)}
                            value={dimension.quantity.value}
                            min="1"
                            step="1"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-", "."].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="absolute right-2 top-2 flex space-x-2">
                      {index === formData.dimensions.length - 1 && (
                        <button
                          type="button"
                          onClick={handleAddDimension}
                          className="px-2 py-1 text-sm bg-green-500 text-white rounded hover:bg-blue-600"
                        >
                          +
                        </button>
                      )}
                      {formData.dimensions.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveDimension(index)}
                          className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                        >
                          -
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full flex gap-5 items-center mt-8">
              <div className="flex items-center gap-4">
                <h2 className="text-xl font-bold">Item details</h2>
                <FaCirclePlus
                  className="text-[22px] text-[#03336e]"
                  onClick={handleAddMore}
                />
              </div>
              <div className="flex items-center gap-2">
                <h1 className="mt-2">Currency</h1>
                <select
                  className="p-1 w-full text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name="itemsCurrency"
                  id="itemsCurrency"
                  onChange={handleInputChange}
                  value={formData.itemsCurrency}
                >
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <h1 className="mt-2">Service</h1>
                <select
                  className="p-1 w-full text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                  name="selectedService"
                  id="selectedService"
                  onChange={handleInputChange}
                  value={
                    formData.selectedService === "EOR & IOR"
                      ? "IOR&EOR"
                      : formData.selectedService
                  }
                >
                  <option value="IOR">IOR</option>
                  <option value="EOR">EOR</option>
                  <option value="IOR&EOR">IOR and EOR</option>
                </select>
              </div>
            </div>
            <div>
              {formData.items.map((formItem, index) => (
                <div key={`item-${index}`} className="md:px-0">
                  <h2 className="flex gap-3 items-center text-[16px] font-bold text-[gray] mt-6">
                    Item details
                    <button onClick={() => handleRemoveService(index)}>
                      <FaCircleMinus />
                    </button>
                  </h2>
                  <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                    <div className="flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`itemName-${index}`}
                      >
                        <span className="text-red-500">*</span> Item Name
                      </label>
                      <input
                        type="text"
                        className={getInputClassName(`itemName-${index}`)}
                        id={`itemName-${index}`}
                        readOnly={isReadOnly}
                        onChange={(e) =>
                          handleServiceInputChange(index, "itemName", e)
                        }
                        value={formItem.itemName}
                      />
                    </div>
                    <div className="flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`quantity-${index}`}
                      >
                        <span className="text-red-500">*</span> Quantity
                      </label>
                      <input
                        type="number"
                        className={getInputClassName(`quantity-${index}`)}
                        readOnly={isReadOnly}
                        id={`quantity-${index}`}
                        onChange={(e) =>
                          handleServiceInputChange(index, "quantity", e)
                        }
                        value={formItem.quantity}
                        min="0"
                        step="any"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                    <div className="flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`itemValue-${index}`}
                      >
                        <span className="text-red-500">*</span> Item Value
                      </label>
                      <input
                        type="number"
                        className={getInputClassName(`itemValue-${index}`)}
                        id={`itemValue-${index}`}
                        readOnly={isReadOnly}
                        onChange={(e) =>
                          handleServiceInputChange(index, "itemValue", e)
                        }
                        value={formItem.itemValue}
                        min="0"
                        step="any"
                      />
                    </div>
                    <div className="flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`countryOrigin-${index}`}
                      >
                        <span className="text-red-500">*</span> Country of Origin
                      </label>
                      <Select
                        showSearch
                        id={`countryOrigin-${index}`}
                        className={getSelectClassName(`countryOrigin-${index}`)}
                        readOnly={isReadOnly}
                        options={countries?.map((country, idx) => ({
                          value: country,
                          label: country,
                          key: idx,
                        }))}
                        onChange={(value) =>
                          handleAntdServiceInputChange(
                            index,
                            "countryOrigin",
                            value
                          )
                        }
                        value={formItem.countryOrigin}
                        style={{ width: "100%" }}
                      />
                      {errors[`countryOrigin-${index}`] && (
                        <p className="text-red-500 text-xs mt-1">
                          Country of Origin is required
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col gap-1 py-2">
                      <label className="w-full text-sm font-normal">
                        Do you have Item HS Code?{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div
                        className={`flex gap-4 ${errors[`hasHSCode-${index}`]
                          ? "border border-red-500 rounded-md p-2"
                          : ""
                          }`}
                      >
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name={`hasHSCode-${index}`}
                            value="yes"
                            checked={formData.items[index].hasHSCode === true}
                            readOnly={isReadOnly}
                            onChange={(e) =>
                              handleServiceInputChange(index, "hasHSCode", e)
                            }
                            className="mr-2"
                          />
                          Yes
                        </label>
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name={`hasHSCode-${index}`}
                            value="no"
                            readOnly={isReadOnly}
                            checked={formData.items[index].hasHSCode === false}
                            onChange={(e) =>
                              handleServiceInputChange(index, "hasHSCode", e)
                            }
                            className="mr-2"
                          />
                          No
                        </label>
                      </div>

                      {formData.items[index].hasHSCode && (
                        <div className="mt-2">
                          <div className="flex items-center gap-2 mb-2">
                            <label className="flex items-center">
                              <input
                                type="radio"
                                name={`hsCodeSource-${index}`}
                                value="database"
                                checked={formData.items[index].hsCodeSource !== 'manual'}
                                onChange={(e) => {
                                  const updatedItems = [...formData.items];
                                  updatedItems[index].hsCodeSource = 'database';
                                  updatedItems[index].itemHSCode = ''; // Clear current value when switching
                                  setFormData(prev => ({ ...prev, items: updatedItems }));
                                }}
                                className="mr-1"
                                disabled={isReadOnly}
                              />
                              Search from Database
                            </label>
                            <label className="flex items-center">
                              <input
                                type="radio"
                                name={`hsCodeSource-${index}`}
                                value="manual"
                                checked={formData.items[index].hsCodeSource === 'manual'}
                                onChange={(e) => {
                                  const updatedItems = [...formData.items];
                                  updatedItems[index].hsCodeSource = 'manual';
                                  updatedItems[index].itemHSCode = ''; // Clear current value when switching
                                  setFormData(prev => ({ ...prev, items: updatedItems }));
                                }}
                                className="mr-1"
                                disabled={isReadOnly}
                              />
                              Enter Manually
                            </label>
                          </div>

                          {formData.items[index].hsCodeSource === 'manual' ? (
                            // Manual input field
                            <input
                              type="text"
                              placeholder="Enter HS Code (first 6 digits must be numbers)"
                              value={formData.items[index].itemHSCode || ''}
                              onChange={(e) => {
                                let value = e.target.value;

                                // Validation: first 6 characters must be digits
                                if (value.length > 0) {
                                  const first6 = value.substring(0, 6);
                                  if (!/^\d{1,6}$/.test(first6)) {
                                    // If first 6 characters are not all digits, prevent the change
                                    return;
                                  }
                                }

                                handleServiceInputChange(index, "itemHSCode", {
                                  target: { value }
                                });
                              }}
                              className={`w-full p-2 text-sm border rounded-md outline-none ${errors[`itemHSCode-${index}`] ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
                                }`}
                              disabled={isReadOnly}
                            />
                          ) : (
                            // Database search (existing AsyncSelect)
                            <AsyncSelect
                              key={`${index}-${formData.items[index].itemHSCode || 'empty'}`}
                              cacheOptions
                              loadOptions={loadHSCodeOptions}
                              defaultOptions
                              onChange={(selectedOption) => {
                                handleServiceInputChange(index, "itemHSCode", {
                                  target: { value: selectedOption ? selectedOption.value : '' }
                                });
                              }}
                              value={formData.items[index].itemHSCode ? {
                                value: formData.items[index].itemHSCode,
                                label: formData.items[index].itemHSCode
                              } : null}
                              placeholder="Search HS Code (min 6 digits)"
                              isClearable
                              isDisabled={isReadOnly || !formData.destinationCountry}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: '32px',
                                  height: '32px',
                                  borderColor: errors[`itemHSCode-${index}`] ? '#ef4444' : base.borderColor,
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: '32px',
                                  padding: '0 8px',
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: '0',
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: '32px',
                                }),
                              }}
                            />
                          )}

                          {errors[`itemHSCode-${index}`] && (
                            <p className="text-red-500 text-xs mt-1">
                              {typeof errors[`itemHSCode-${index}`] === 'string'
                                ? errors[`itemHSCode-${index}`]
                                : "HS Code must be at least 6 digits"
                              }
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-1 py-2">
                      <label className="w-full text-sm font-normal">
                        Is your Item New?{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div
                        className={`flex gap-4 ${errors[`itemNew-${index}`]
                          ? "border border-red-500 rounded-md p-2"
                          : ""
                          }`}
                      >
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name={`itemNew-${index}`}
                            readOnly={isReadOnly}
                            value="yes"
                            checked={formData.items[index].itemNew === true}
                            onChange={(e) =>
                              handleServiceInputChange(index, "itemNew", e)
                            }
                            className="mr-2"
                          />
                          Yes
                        </label>
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name={`itemNew-${index}`}
                            readOnly={isReadOnly}
                            value="no"
                            checked={formData.items[index].itemNew === false}
                            onChange={(e) =>
                              handleServiceInputChange(index, "itemNew", e)
                            }
                            className="mr-2"
                          />
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6 mt-6 mb-6">
              {/* Import Documentation - Show only if not EOR */}
              {formData.selectedService !== "EOR" && (
                <div className="flex flex-col md:w-1/2">
                  <label
                    htmlFor="requiredDoc"
                    className="block mb-2 text-md font-normal text-black"
                  >
                    Import documentation required? <span className="text-red-500">*</span>
                  </label>
                  <div className={`flex gap-4 ${errors.requiredDoc ? "p-2 border border-red-500 rounded-sm" : ""}`}>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="requiredDoc"
                        value="Required"
                        onChange={handleInputChange}
                        checked={formData.requiredDoc === "Required"}
                        className="form-radio h-4 w-4 text-cus-blue"
                      />
                      <span className="ml-1 md:ml-2">Required</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="requiredDoc"
                        value="not_Required"
                        onChange={handleInputChange}
                        checked={formData.requiredDoc === "not_Required"}
                        className="form-radio h-4 w-4 text-cus-blue"
                      />
                      <span className="ml-1 md:ml-2">Not Required</span>
                    </label>
                  </div>
                </div>
              )}

              {/* ECCN Code - Show only if EOR */}
              {(formData.selectedService === "EOR" || formData.selectedService === "EOR & IOR") && (
                <div className="flex flex-col md:w-1/2">
                  <label
                    htmlFor="eccnCode"
                    className="block mb-2 text-md font-normal text-black"
                  >
                    ECCN Code <span className="text-red-500">*</span>
                  </label>
                  <Select
                    showSearch
                    placeholder="Select ECCN Code"
                    value={formData.eccnCode}
                    onChange={(value) => setSelectedEccn(value)}
                    className={errors.eccnCode ? "border-red-500" : ""}
                    style={{ width: "100%" }}
                    optionLabelProp="label"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.props.children.some(child =>
                        child.toString().toLowerCase().includes(input.toLowerCase())
                      )
                    }
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  >
                    {eccnCodes.map((eccn) => (
                      <Select.Option
                        key={eccn.eccn_code}
                        value={eccn.eccn_code}
                        label={eccn.eccn_code}
                      >
                        {renderEccnOption(eccn)}
                      </Select.Option>
                    ))}
                  </Select>
                  {errors.eccnCode && (
                    <p className="text-red-500 text-xs mt-1">
                      ECCN Code is required for EOR service
                    </p>
                  )}
                </div>
              )}

              {/* Insurance section */}
              <div className="flex flex-col md:w-1/2">
                <label className="block mb-2 text-md font-normal text-black">
                  Do you need insurance? <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center">
                  <label className="inline-flex items-center mr-4">
                    <input
                      type="radio"
                      className="form-radio h-4 w-4 text-cus-blue"
                      name="insurance"
                      value="YES"
                      checked={formData.insuranceSelected === "YES"}
                      onChange={() => handleInsuranceChange("YES")}
                    />
                    <span className="ml-1 md:ml-2">Yes</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      className="form-radio h-4 w-4 text-cus-blue"
                      name="insurance"
                      value="NO"
                      checked={formData.insuranceSelected === "NO"}
                      onChange={() => handleInsuranceChange("NO")}
                    />
                    <span className="ml-1 md:ml-2">No</span>
                  </label>
                </div>
              </div>
            </div>
            {renderEstimateSummary()}

            {showButton && (
              <div className="relative flex justify-center items-center mt-12">
                <button
                  onClick={handleGetEstimate}
                  className="bg-cus-blue hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="flex items-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </span>
                  ) : (
                    buttonText
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Estimate Submission Confirmation"
      >
        <div className="text-center">
          <FaCheckCircle className="text-green-500 text-5xl mb-4 mx-auto" />
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            Estimate {estimate ? "Updated" : "Submitted"} Successfully!
          </h2>
          <p className="mb-6 text-gray-600">
            Great news! Admins have received your estimation request. You'll get
            an email and a notification in your dashboard once they've created
            an estimate for your product. Stay tuned for updates!
          </p>
          <p className="mb-6 text-gray-600">
            You can accept the estimation in the New Request Sidebar Tab and inside the IOR Estimate.
          </p>
          <button
            onClick={closeModal}
            className="bg-cus-blue hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Got it, thanks!
          </button>
        </div>
      </Modal>
      <WarningPopup
        isOpen={warningPopup.isOpen}
        message={warningPopup.message}
        onClose={() => setWarningPopup({ isOpen: false, message: "" })}
        formData={formData}
      />
    </>
  );
};

export default EstimateForm;